let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gmQK3")).then(() => parcelRequire('6TjtY'));